import React from "react";
import Email from "../images/Email.svg";
import Password from "../images/Password.svg";

export default function InputGroup({
  type = "email",
  label,
  placeholder,
  required = false,
  value,
  setValue,
}) {
  return (
    <div className="mt-4 mb-4">
      <label>{label}</label>
      <div className="relative mb-6">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <img src={type === "email" ? Email : Password} className="w-4 h-4" />
        </div>
        <input
          type={type === "email" ? "email" : "password"}
          minLength={type === "email" ? 15 : 8}
          className="border border-gray-300 text-gray-900 text-sm rounded-md focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 block w-full py-2 pl-[35px] pr-[15px] md:pl-[35px] pr-[15px]"
          placeholder={placeholder}
          required={required}
          onChange={(e) => setValue(e.target.value)}
          autoComplete={"off"}
          value={value}
        />
      </div>
    </div>
  );
}
